import type { BestellzeileEingabe, SpeiseAnsicht } from "../api";

/** Eine Zeile im Warenkorb: eine gewählte Speise plus die (kostenlos) wegzulassenden Zutaten. */
export interface Warenkorbzeile {
  /** Stabiler Schlüssel für die React-Liste; erlaubt dieselbe Speise mehrfach mit anderen Weglassungen. */
  schluessel: string;
  speise: SpeiseAnsicht;
  weglassen: string[];
}

/** Erzeugt eine neue Warenkorbzeile ohne Weglassungen. */
export function neueZeile(speise: SpeiseAnsicht): Warenkorbzeile {
  return { schluessel: crypto.randomUUID(), speise, weglassen: [] };
}

/** Vorläufige Zwischensumme (nur Speisen, ohne Liefergebühr) — die API rechnet verbindlich. */
export function zwischensummeCent(warenkorb: Warenkorbzeile[]): number {
  return warenkorb.reduce((summe, zeile) => summe + zeile.speise.stueckpreisCent, 0);
}

/** Übersetzt den Warenkorb in die API-Eingabe (speiseId + optionale Weglassungen). */
export function zuBestellzeilen(warenkorb: Warenkorbzeile[]): BestellzeileEingabe[] {
  return warenkorb.map((zeile) => ({
    speiseId: zeile.speise.id,
    ...(zeile.weglassen.length > 0 ? { weglassen: zeile.weglassen } : {}),
  }));
}
